import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import { useRehydrateTokens } from '@digiwedge/hooks-auth-web';
import { Login } from '@digiwedge/ui-antd';

import { IdpProvider } from './auth/IdpProvider.js';
import RequireAuth from './auth/RequireAuth.js';
import AdminLayout from './layout/AdminLayout.js';
import PublicHomePage from './pages/PublicHomePage.js';
import AdminHomePage from './pages/admin/AdminHomePage.js';
import PricingAdminPage from './pages/admin/PricingAdminPage.js';
import ContentAdminPage from './pages/admin/ContentAdminPage.js';
import OrdersAdminPage from './pages/admin/OrdersAdminPage.js';

export function App() {
  useRehydrateTokens();

  return (
    <IdpProvider>
      <Routes>
        <Route path="/" element={<PublicHomePage />} />
        <Route
          path="/login"
          element={
            <Login
              appName="YOLO Admin"
              heroTitle="YOLO Admin"
              heroSubtitle="Manage pricing, contracts, content, and orders for your e-commerce platform"
              defaultRemember={true}
              overlay="none"
              redirectTo="/admin"
            />
          }
        />
        <Route element={<RequireAuth />}>
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<AdminHomePage />} />
            <Route path="pricing" element={<PricingAdminPage />} />
            <Route path="content" element={<ContentAdminPage />} />
            <Route path="orders" element={<OrdersAdminPage />} />
          </Route>
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </IdpProvider>
  );
}

export default App;
